
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
    .state('workplan.projectsFormulation', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/projectsFormulation',
      views: {
        '': {
          template: require('./projectsFormulation/list/index.html')
        },
        'principal@': {
          template: require('./projectsFormulation/list/projectsFormulationList.html'),
          controller: 'ProjectsFormulationListCtrl',
          controllerAs: 'projectsFormulationVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Formulación de propuesta',
        order: 1,
        title: 'Investigación e innovación',
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.investigation', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/projectsFormulation',
      views: {
        '': {
          template: require('./projectsFormulation/list/index.html')
        },
        'principal@': {
          template: require('./projectsFormulation/list/projectsFormulationList.html'),
          controller: 'ProjectsFormulationListCtrl',
          controllerAs: 'projectsFormulationVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Investigación',
        order: 1,
        title: 'Investigación e innovación',
        siblings: [
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createProjectFormulation', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/projectsFormulation/createProjectFormulation/:workplanTeacherActivityId',
      template: require('./projectsFormulation/createProjectFormulation/createProjectFormulation.html'),
      controller: 'CreateProjectFormulationCtrl',
      controllerAs: 'createProjectFormulationVm',
      data: {
        displayName: 'Formulación de propuesta',
        title: 'Investigación e innovación',
        order: 1,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.projects', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/projects',
      template: require('./projects/list/projectsList.html'),
      controller: 'ProjectsListCtrl',
      controllerAs: 'projectsVm',
      data: {
        displayName: 'Proyectos',
        title: 'Investigación e innovación',
        order: 2,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createProject', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/projects/createProject/:workplanTeacherActivityId',
      template: require('./projects/createProject/createProject.html'),
      controller: 'CreateProjectCtrl',
      controllerAs: 'createProjectVm',
      data: {
        displayName: 'Proyectos',
        title: 'Investigación e innovación',
        order: 2,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.products', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/products',
      template: require('./products/list/productsList.html'),
      controller: 'ProductsListCtrl',
      controllerAs: 'productsVm',
      data: {
        displayName: 'Productos',
        title: 'Investigación e innovación',
        order: 3,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createProduct', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/products/createProduct/:workplanTeacherActivityId',
      template: require('./products/createProduct/createProduct.html'),
      controller: 'CreateProductCtrl',
      controllerAs: 'createProductVm',
      data: {
        displayName: 'Productos',
        title: 'Investigación e innovación',
        order: 3,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.collaborationSpaces', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/collaborationSpaces',
      views: {
        '': {
          template: require('./collaborationSpaces/list/index.html')
        },
        'principal@': {
          template: require('./collaborationSpaces/list/collaborationSpacesList.html'),
          controller: 'CollaborationSpacesListCtrl',
          controllerAs: 'collaborationSpacesVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Espacio de colaboración',
        title: 'Investigación e innovación',
        order: 4,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
     .state('workplan.createSpace', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/createSpace/:workplanTeacherActivityId',
      template: require('./collaborationSpaces/createSpace/createSpace.html'),
      controller: 'CreateSpaceCtrl',
      controllerAs: 'createSpaceVm',
      data: {
        displayName: 'Espacio de colaboración',
        title: 'Investigación e innovación',
        order: 4,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })

    .state('workplan.trainingResearch', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/trainingResearch',
      views: {
        '': {
          template: require('./trainingResearch/list/index.html')
        },
        'principal@': {
          template: require('./trainingResearch/list/trainingResearchList.html'),
          controller: 'TrainingResearchListCtrl',
          controllerAs: 'trainingResearchVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Formación en investigación',
        title: 'Investigación e innovación',
        order: 5,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createTrainingResearch', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/createTrainingResearch/:workplanTeacherActivityId',
      template: require('./trainingResearch/createTrainingResearch/createTrainingResearch.html'),
      controller: 'CreateTrainingResearchCtrl',
      controllerAs: 'createTrainingVm',
      data: {
        displayName: 'Formación en investigación',
        title: 'Investigación e innovación',
        order: 5,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.resultsTransfer',
            order: 6
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.resultsTransfer', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/resultsTransfer',
      views: {
        '': {
          template: require('./resultsTransfer/list/index.html')
        },
        'principal@': {
          template: require('./resultsTransfer/list/resultsTransferList.html'),
          controller: 'ResultsTransferListCtrl',
          controllerAs: 'resultsTransferVm'
        },
        'indicators@': {
          template: require('../indicators/indicators.html'),
          controller: 'IndicatorsCtrl',
          controllerAs: 'indicatorsVm'
        }
      },
      data: {
        displayName: 'Transferencia de resultados',
        title: 'Investigación e innovación',
        order: 6,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
    .state('workplan.createResultsTransfer', {
      moduleId: GlobalConfig.modules.investigation,
      abstract: false,
      url: '/research/createResultsTransfer/:workplanTeacherActivityId',
      template: require('./resultsTransfer/createResultsTransfer/createResultsTransfer.html'),
      controller: 'CreateResultsTransferCtrl',
      controllerAs: 'createTransferVm',
      data: {
        displayName: 'Transferencia de resultados',
        title: 'Investigación e innovación',
        order: 6,
        siblings: [
          {
            name: 'fullscreen.workPlanGeneralInformation',
            order: 0
          },
          {
            name: 'workplan.projectsFormulation',
            order: 1
          },
          {
            name: 'workplan.projects',
            order: 2
          },
          {
            name: 'workplan.products',
            order: 3
          },
          {
            name: 'workplan.collaborationSpaces',
            order: 4
          },
          {
            name: 'workplan.trainingResearch',
            order: 5
          },
          {
            name: 'workplan.history',
            order: 7
          }
        ]
      },
      params: {
        indicatorType: GlobalConfig.indicatorsType.research,
        stage: GlobalConfig.workplanStages.planning
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/research.route.js